export default function sanitize(text, options) {
  const DOMPurify = require('dompurify')
  return DOMPurify.sanitize(text, options)
}
